import e from"styled-components";const t=e.span`
	color: ${({theme:e})=>e.text.link};
	font-size: 10px;
	font-weight: 400;
	line-height: 17px;
	user-select: none;
	cursor: pointer;
	display: flex;
	align-items: center;
`;export{t as Preview};
